import * as React from 'react';

import { TravelModeContainer } from 'containers/project-love/features/travel-mode-container';

const Page: React.FunctionComponent = () => {
  return <TravelModeContainer />;
};

export default Page;

export { getServerSideProps } from 'lib/get-server-side-props';
